module.exports = __webpack_public_path__ + "static/media/mute.84ecf35a.svg";